import React from "react";
import { Redirect, Switch } from "react-router-dom";
// import Profile from "./personalInformation/Profile";
import Profile from "../profile/personalInformation/Profile";
import { useHistory } from "react-router-dom";
import ProfileTabs from "./Tabs";
import Travels from "./Travels/Travels";
import Transaction from "./Transaction/Transaction";
import Recharge from "./Recharge/Recharge";
import Passengers from "./passengers/Passengers";
import Support from "./Support/Support";
import { ContentRoute } from "../../../_metronic/layout";
import * as Scroll from "react-scroll";

const ProfileMainPage = (props) => {
  let scroll = Scroll.animateScroll;
  const history = useHistory();
  const splittedURL = history.location.pathname.split("/");

  React.useEffect(() => {
    scroll.scrollToTop();
  }, []);

  return (
    <>
      <ProfileTabs url={splittedURL[2] ? splittedURL[2] : "profile"} />
      <Switch>
        {" "}
        <ContentRoute path="/account/profile" component={Profile} />
        <ContentRoute path="/account/travels" component={Travels} />
        <ContentRoute path="/account/transaction" component={Transaction} />
        {/* <ContentRoute path="/account/recharge" component={Recharge} /> */}
        <ContentRoute path="/account/passengers" component={Passengers} />
        <ContentRoute path="/account/support" component={Support} />
      </Switch>
    </>
  );
};

export default ProfileMainPage;
